import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Button, Row, Col } from "reactstrap";
import ModalFrame from "../../../../toolkit/modalFrame";
import BaseNumericInput from "../../../../toolkit/baseNumericInput";
import { handleRequestError } from "../../../../utils/helpers";
import { generateGuestsPassesDiscounts } from "../../../actions/partners";
import DatePicker from "../../common/DatePicker";
import moment from "moment";

interface Props {
  isOpen: boolean;
  partnerMembershipId: String;
  onOk: () => void;
  onCancel: () => void;
}

interface State {
  fields: {
    noPasses: number;
    finVigencia: number;
  };
  loading: boolean;
  errores: {
    noPasses: string[];
  };
}

class ModalAddGuestPassesDiscounts extends React.Component<Props, State> {
  state = {
    fields: {
      noPasses: 0,
      finVigencia: null
    },
    loading: false,
    errores: {
      noPasses: []
    }
  };

  clearState = () => {
    const { fields } = this.state;
    fields.noPasses = 0;
    fields.finVigencia = null;
    this.setState({
      fields: { ...fields },
      errores: { noPasses: [] }
    });
  };

  onOkButton = async () => {
    //CALLS endpoint
    const { partnerMembershipId: membresiaSocioId } = this.props;
    const { fields } = this.state;
    const { noPasses: noPases, finVigencia } = fields;

    const data = [
      {
        membresiaSocioId,
        noPases,
        finVigencia
      }
    ];

    this.setState({ loading: true });
    try {
      await generateGuestsPassesDiscounts(this.props.partnerMembershipId, data);
      this.clearState();
      if (!!this.props.onOk) {
        this.props.onOk();
      }
    } catch (error) {
      handleRequestError(error);
    }

    this.setState({ loading: false });
  };

  onCancelButton = () => {
    this.clearState();

    if (!!this.props.onCancel) {
      this.props.onCancel();
    }
  };

  onChangeNumberFactory = fieldName => {
    return event => {
      const value = event.target.value.replace(/[^0-9]/gi, "");
      const numValue = parseInt(value, 10);
      const errores = [];

      if (value !== "" && (isNaN(numValue) || numValue < 1)) {
        errores.push("Número inválido");
      }

      if (value !== "" && numValue > 100) {
        errores.push("No puede crear más de 100 pases");
      }

      this.setState(state => {
        const fields = {
          ...state.fields,
          [fieldName]: value
        };
        return {
          ...state,
          fields,
          errores: {
            noPasses: errores
          }
        };
      });
    };
  };

  onChangeDate = fieldName => {
    return event => {
      const date = moment(event).format("YYYY-MM-DD");
      const fields = {
        ...this.state.fields,
        [fieldName]: date
      };
      this.setState({ fields });
    };
  };

  render() {
    return (
      <ModalFrame
        title={`Creación de descuentos para pases de invitado`}
        isOpen={this.props.isOpen}
        toggle={this.onCancelButton}
        size="md"
      >
        <Row>
          <Col>
            <BaseNumericInput
              label={"# descuentos para pases de invitado"}
              name="noGuestsPasses"
              id="noGuestsPasses"
              value={this.state.fields.noPasses}
              errors={this.state.errores.noPasses}
              onChange={this.onChangeNumberFactory("noPasses")}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <DatePicker
              label="Fin vigencia"
              name="endDate"
              id="endDate"
              selected={this.state.fields.finVigencia}
              onChange={this.onChangeDate("finVigencia")}
            />
          </Col>
        </Row>

        <Row className="mt-4">
          <Col xs={6} md={6} lg={6}>
            <Button
              className={`${s.primaryButton}`}
              block
              color="secondary"
              onClick={() => {
                this.onOkButton();
              }}
              disabled={
                this.state.loading ||
                !this.state.fields.noPasses ||
                this.state.errores.noPasses.length > 0
              }
            >
              {this.state.loading ? "GUARDANDO..." : "CREAR DESCUENTOS"}
            </Button>
          </Col>
          <Col xs={6} md={6} lg={6}>
            <Button
              block
              color="secondary"
              onClick={() => {
                this.onCancelButton();
              }}
              disabled={this.state.loading}
            >
              CANCELAR
            </Button>
          </Col>
        </Row>
      </ModalFrame>
    );
  }
}

export default withRouter(withStyles(s)(ModalAddGuestPassesDiscounts));
